import React, { useEffect, useState } from "react";
import {
    Accordion,
    AccordionItem,
    AccordionButton,
    AccordionPanel,
    AccordionIcon,
} from "@chakra-ui/react";
import { Box, Grid } from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
import Skeleton from "@mui/material/Skeleton";
import getDateFromString from "../../utils/getDateFromString";
import { filterPayment } from "../../store/action/payment";
import DialogContent from "@material-ui/core/DialogContent";
import {IoCloseOutline} from "react-icons/io5";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import ReglementGarageDialog from "./ReglementGarageDialog";
import ReglementExpertDialog from "./ReglementExpertDialog";
import ReglementFooterButtons from "./ReglementFooterButtons";
import {getLabelClass, renderInputOrSpan} from "../../utils/formUtils";
import {toggleExpansion} from "../../utils/toggleExpansion";
import { hasAuthorities } from "../../utils/authoritiesUtils";

const useStyles = makeStyles((theme) => ({
    labelInput: {
        fontFamily: "Poppins",
        fontSize: "12px",
        fontWeight: 400,
        lineHeight: "18px",
        textAlign: "left",
        color: "rgba(70, 78, 95, 1)",
        marginBottom: "10px",
    },
    styleInput: {
        borderRadius: "4px",
        border: 0,
        background: "rgba(243, 246, 249, 1)",
        height: "36px",
        width: "250px",
        padding: "14px",
        fontFamily: "Poppins",
        fontSize: "12px",
        fontWeight: 400,
        lineHeight: "18px",
        textAlign: "left",
        color: "rgba(70, 78, 95, 1)",
    },
    paper: {
        width: "100%",
        boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.06)",
        maxWidth: "800px",
    },
    customAccordionItem: {
        width: "100%",
        marginBottom: "20px",
        borderRadius: "11px",
        border: `1px solid rgba(187, 200, 8, 1)`,
    },
    viewReglementDetails: {
        fontFamily: "Poppins",
        fontWeight: 500,
        fontSize: "15px",
        color: "rgba(187, 200, 8, 1)",
        textAlign: "right",
    },
    dialogPaper: {
        maxWidth: '100%',
        width: "536px",
        height: "652px",
        borderRadius: '8px',
    },
    dialogTitle: {
        width: "535px",
        height: "60px",
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        //marginBottom: '15px',
        backgroundColor: "rgba(244, 244, 244, 1)",
        color: "rgba(63, 66, 84, 1)",
        fontSize: "18px",
        fontWeight: 500,
        fontFamily: "Poppins",
    },
    closeButton: {
        cursor: 'pointer',
        marginLeft: "290px",
        textAlign: "right",
        alignItems: 'center',
    },
    dialogContent: {
        overflowX: "hidden",
        overflowY: "auto",
        "&::-webkit-scrollbar": {
            width: "5px",
        },
        "&::-webkit-scrollbar-track": {
            background: "rgba(217, 217, 217, 0.5)",
        },
        "&::-webkit-scrollbar-thumb": {
            background: "rgba(187, 200, 8, 0.58)",
            borderRadius: "5px",
        },
    },
    dialogBody: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
    },
    styleInputDestinataire: {
        fontFamily: "Poppins",
        fontSize: "12px",
        fontWeight: 400,
        lineHeight: "18px",
        textAlign: "left",
        color: "rgba(187, 200, 8, 1)",
        textDecoration: "underline",
        marginBottom: "10px",
        borderRadius: "4px",
        border: 0,
        background: "rgba(243, 246, 249, 1)",
        height: "36px",
        width: "250px",
        padding: "14px",
    },
    styleSpan:{
        color: 'rgba(70, 78, 95, 1)',
        fontSize: '12px',
        fontWeight: 400,
        fontFamily: 'Poppins'
    },
    styleSpanLabel:{
        color: 'rgba(70, 78, 95, 1)',
        fontSize: '12px',
        fontWeight: 600,
        fontFamily: 'Poppins'
    },
    expanded: {
        border: "none",
    },
}));

function ReglementHonorairesSection(props) {
    const classes = useStyles();
    const [loading, setLoading] = useState(true);
    const [paymentExpertData, setPaymentExpertData] = useState(null);
    const [paymentGarageData, setPaymentGarageData] = useState(null);
    const [open, setOpen] = useState(false);
    const [dialogContent, setDialogContent] = useState("");
    const claimNumber = props.claimNumber
    const renderAsSpans = props.renderAsSpans 
    const [expandedItems, setExpandedItems] = useState(new Set([0]));

    useEffect(() => {
        const fetchPayments = async () => {
            setLoading(true);
            try {
                const response = await filterPayment(claimNumber); 
                const paymentExpert = response.filter((obj) => obj.__t === "paymentInspector")[0];
                const paymentRepair = response.filter((obj) => obj.__t === "paymentRepair")[0];
                setPaymentExpertData(paymentExpert);
                setPaymentGarageData(paymentRepair);
            } catch (error) {
                console.error(`Error fetching task details: ${error.message}`);
            }
            setLoading(false);
        };
        fetchPayments().then(r => console.log("Fetch payments complete"));
    }, [claimNumber]);


    const handleClickOpen = (content) => {
        setDialogContent(content);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const renderPaymentDetails = (payment) => {
        if (!payment) {
            return null;
        }

        return (
            <Grid container wrap="nowrap" spacing={2}>
                {payment.__t === "paymentInspector" && (
                    <>
                        <Grid item>
                            <div>
                                <div className={getLabelClass(renderAsSpans, classes)} style={{marginRight: "40px"}}>Déstinataire</div>
                                {/*<input*/}
                                {/*    className={classes.styleInputDestinataire}*/}
                                {/*    name="inspectorCode"*/}
                                {/*    type="text"*/}
                                {/*    value={payment.inspectorCode || "N/A"}*/}
                                {/*    disabled*/}
                                {/*/>*/}
                                {renderInputOrSpan(renderAsSpans, payment.inspectorCode  || "N/A", classes)}
                            </div>
                        </Grid>
                        <Grid item>
                            <div>
                                <div className={getLabelClass(renderAsSpans, classes)} style={{marginRight: "40px"}}>Date création</div>
                                {/*<input*/}
                                {/*    className={classes.styleInput}*/}
                                {/*    name="designationDate"*/}
                                {/*    type="text"*/}
                                {/*    value={getDateFromString(payment.designationDate || 'N/A' )}*/}
                                {/*    disabled*/}
                                {/*/>*/}
                                {renderInputOrSpan(renderAsSpans, getDateFromString(payment.designationDate) || "N/A", classes)}
                            </div>
                        </Grid>
                        <Grid item>
                            <div>
                                <div className={getLabelClass(renderAsSpans, classes)} style={{marginRight: "40px"}}>Montant totale TTC</div>
                                {/*<input*/}
                                {/*    className={classes.styleInput}*/}
                                {/*    name="totalInspectorAmountTTC"*/}
                                {/*    type="text"*/}
                                {/*    value={payment.totalAmountTcc || "Pièce non disponible"}*/}
                                {/*    disabled*/}
                                {/*/>*/}
                                {renderInputOrSpan(renderAsSpans, payment.inspectionAmount  , classes)}
                            </div>
                        </Grid>
                         
                    </>
                )}

                {payment.__t === "paymentRepair" && (
                    <>
                        <Grid item>
                            <div>
                                <div className={getLabelClass(renderAsSpans, classes)} style={{marginRight: "40px"}}>Déstinataire</div>
                                {/*<input*/}
                                {/*    className={classes.styleInputDestinataire}*/}
                                {/*    name="garageCode"*/}
                                {/*    type="text"*/}
                                {/*    value={payment.garageCode || "N/A"}*/}
                                {/*    disabled*/}
                                {/*/>*/}
                                {renderInputOrSpan(renderAsSpans, payment.garageCode || "N/A", classes)}
                            </div>
                        </Grid>
                        <Grid item>
                            <div>
                                <div className={getLabelClass(renderAsSpans, classes)} style={{marginRight: "40px"}}>Date création</div>
                                {/*<input*/}
                                {/*    className={classes.styleInput}*/}
                                {/*    name="dateIssuedOn"*/}
                                {/*    type="text"*/}
                                {/*    value={getDateFromString(payment.issuedOn || 'N/A')}*/}
                                {/*    disabled*/}
                                {/*/>*/}
                                {renderInputOrSpan(renderAsSpans, getDateFromString(payment.issuedOn) || "N/A", classes)}
                            </div>
                        </Grid>
                        <Grid item>
                            <div>
                                <div className={getLabelClass(renderAsSpans, classes)} style={{marginRight: "40px"}}>Montant totale TTC</div>
                                {/*<input*/}
                                {/*    className={classes.styleInput}*/}
                                {/*    name="totalRepairAmountTTC"*/}
                                {/*    type="text"*/}
                                {/*    value={payment.totalRepairAmountWTax || "Pièce non disponible"}*/}
                                {/*    disabled*/}
                                {/*/>*/}
                                {renderInputOrSpan(renderAsSpans, payment.totalRepairAmountWTax  , classes)}
                            </div>
                        </Grid>
                         
                    </>
                )}
            </Grid>
        );
    };

    return (
        <div style={{ padding: "40px" }}>
          <Accordion defaultIndex={[0]} allowMultiple>
  {loading ? (
    <>
      <SkeletonLoader classes={classes} />
      <SkeletonLoader classes={classes} />
    </>
  ) : (
    <>
      {hasAuthorities("VIEW_HONORAIRE_EXPERT") && paymentExpertData && (
        <AccordionItem
          className={`${classes.customAccordionItem} ${renderAsSpans ? classes.expanded : ''}`}
          key={0}
        >
          <AccordionButton
            onClick={() => toggleExpansion(0, expandedItems, setExpandedItems)}
            style={{
              height: "47px",
              border: "none",
              background: "rgba(249, 249, 249, 1)",
              padding: "10px",
              borderRadius: "11px",
            }}
          >
            <AccordionIcon
              size="30px"
              style={{
                backgroundColor: "rgba(240, 243, 199, 1)",
                width: "25px",
                height: "25px",
                borderRadius: "5px",
                color: "rgba(187, 200, 8, 1)",
              }}
            />
            <Box
              as="span"
              textAlign="left"
              marginLeft="20px"
              style={{
                color: "rgba(0, 34, 38, 1)",
                fontSize: "15px",
                fontWeight: 500,
                lineHeight: "21px",
                fontFamily: "Poppins",
              }}
            >
              Honoraries Expert
            </Box>
            <div style={{ flexGrow: 1 }} />
            <span
              className={classes.viewReglementDetails}
              onClick={() => handleClickOpen("Honoraries Expert")}
            >
              Voir Détail Réglement
            </span>
          </AccordionButton>
          <AccordionPanel
            style={{
              width: "100%",
              background: "rgba(255, 255, 255, 1)",
              padding: "30px",
              borderRadius: "11px",
            }}
          >
            {renderPaymentDetails(paymentExpertData)}
          </AccordionPanel>
        </AccordionItem>
      )}
      {hasAuthorities("VIEW_HONORAIRE_REPAIRER") && paymentGarageData && (
        <AccordionItem
          className={`${classes.customAccordionItem} ${expandedItems.has(1) ? classes.expanded : ''}`}
          key={1}
        >
          <AccordionButton
            onClick={() => toggleExpansion(1, expandedItems, setExpandedItems)}
            style={{
              height: "47px",
              border: "none",
              background: "rgba(249, 249, 249, 1)",
              padding: "10px",
              borderRadius: "11px",
            }}
          >
            <AccordionIcon
              size="30px"
              style={{
                backgroundColor: "rgba(240, 243, 199, 1)",
                width: "25px",
                height: "25px",
                borderRadius: "5px",
                color: "rgba(187, 200, 8, 1)",
              }}
            />
            <Box
              as="span"
              textAlign="left"
              marginLeft="20px"
              style={{
                color: "rgba(0, 34, 38, 1)",
                fontSize: "15px",
                fontWeight: 500,
                lineHeight: "21px",
                fontFamily: "Poppins",
              }}
            >
              Honoraries Réparateur
            </Box>
            <div style={{ flexGrow: 1 }} />
            <span
              className={classes.viewReglementDetails}
              onClick={() => handleClickOpen("Honoraries Réparateur")}
            >
              Voir Détail Réglement
            </span>
          </AccordionButton>
          <AccordionPanel
            style={{
              width: "100%",
              background: "rgba(255, 255, 255, 1)",
              padding: "30px",
              borderRadius: "11px",
            }}
          >
            {renderPaymentDetails(paymentGarageData)}
          </AccordionPanel>
        </AccordionItem>
      )}
      {(!paymentExpertData || !hasAuthorities("VIEW_HONORAIRE_EXPERT")) &&
        (!paymentGarageData || !hasAuthorities("VIEW_HONORAIRE_REPAIRER")) && (
          <Box
            style={{
              fontFamily: "Poppins",
              fontWeight: 400,
              fontSize: 15,
              lineHeight: "22.5px",
              color: "rgba(70, 78, 95, 1)",
            }}
          >
            Aucun règlement n'est trouvé pour ce sinistre
          </Box>
        )}
    </>
  )}
</Accordion>

            <Dialog
                open={open}
                onClose={handleClose}
                classes={{ paper: classes.dialogPaper }}
                maxWidth={false}
            >
                <DialogTitle className={classes.dialogTitle}>
                    {dialogContent === "Honoraries Expert" ? (
                        <span>Honoraries Expert</span>
                    ) : (
                        <span>Honoraries Garage</span>
                    )}
                    <IoCloseOutline className={classes.closeButton} size={24} onClick={handleClose} />
                </DialogTitle>
                <DialogContent className={classes.dialogContent}>
                    <div className={classes.dialogBody}>
                        {dialogContent === "Honoraries Expert" ?
                            <ReglementExpertDialog payment={paymentExpertData}/>
                            :
                            <ReglementGarageDialog payment={paymentGarageData}/>
                        }
                    </div>
                </DialogContent>
                <ReglementFooterButtons/>
            </Dialog>
        </div>
    );
}

const SkeletonLoader = ({ classes }) => (
    <AccordionItem className={classes.customAccordionItem}>
        <AccordionButton
            style={{
                height: "47px",
                border: "none",
                background: "rgba(249, 249, 249, 1)",
                padding: "10px",
                borderRadius: "11px",
            }}
        >
            <Skeleton variant="rounded" width={30} height={30} />
            <Box
                as="span"
                textAlign="left"
                marginLeft="20px"
                style={{
                    color: "rgba(0, 34, 38, 1)",
                    fontSize: "15px",
                    fontWeight: 500,
                    lineHeight: "21px",
                    fontFamily: "Poppins",
                }}
            >
                <Skeleton width={200} />
            </Box>
            <div style={{ flexGrow: 1 }} />
            <a href="/" className={classes.viewReglementDetails}>
                Voir Détail Réglement
            </a>
        </AccordionButton>
        <AccordionPanel
            style={{
                width: "100%",
                background: "rgba(255, 255, 255, 1)",
                padding: "30px",
                borderRadius: "11px",
            }}
        >
            <Grid container wrap="nowrap" spacing={2}>
                <Grid item>
                    <Skeleton variant="rectangular" width={210} height={60} />
                </Grid>
                <Grid item>
                    <Skeleton variant="rectangular" width={210} height={60} />
                </Grid>
                <Grid item>
                    <Skeleton variant="rectangular" width={210} height={60} />
                </Grid>
                <Grid item>
                    <Skeleton variant="rectangular" width={210} height={60} />
                </Grid>
            </Grid>
        </AccordionPanel>
    </AccordionItem>
);
export default ReglementHonorairesSection;
